import { useI18n } from 'vue-i18n'

export function useLocalizedName() {
  const { locale } = useI18n()
  return (obj) => {
    if (!obj) return ''
    return locale.value === 'ro' ? obj.name_ro || obj.name_en || '' : obj.name_en || ''
  }
}
